import { registerDestructor } from '@ember/destroyable';

import Cropper from 'cropperjs';

import 'cropperjs/dist/cropper.css';

import Modifier from 'ember-modifier';

const DEFAULT_OPTIONS = {
  autoCrop: true,
  autoCropArea: 1,
  viewMode: 1,
  restore: false,
  responsive: true,
  rotatable: false,
  zoomable: false,
  scalable: false,
  movable: false,
};

export default class ImageCropperModifier extends Modifier {
  // Defaults
  cropper;

  // Hooks
  constructor(owner, args) {
    super(owner, args);

    registerDestructor(this, () => this.destroyCropper.bind(this));
  }

  modify(element, _, namedArgs) {
    element.style.width = '100%';
    if (!this.cropper) {
      this.setupCropper(element, namedArgs);
    } else {
      this.updateCropper(namedArgs);
    }
  }

  setupCropper(element, { data, aspectRatio, onCrop }) {
    this.cropper = new Cropper(element, {
      ...DEFAULT_OPTIONS,
      aspectRatio,
      data,
      crop: onCrop,
    });
  }

  updateCropper({ data, aspectRatio }) {
    this.cropper.setAspectRatio(aspectRatio);
    this.cropper.setData(data);
  }

  destroyCropper() {
    this.cropper?.destroy();
  }
}
